import React, { useImperativeHandle, forwardRef, useState } from "react";
import Location from "../assets/icons/Location";
import { post } from "../network/api";
import { useTranslation } from "react-i18next";
const PlaceSearch = forwardRef(({ onPlaceSelect, getPlaceData }, ref) => {

const { t } = useTranslation();
  const [query, setQuery] = useState("");
  const [places, setPlaces] = useState([]);

  const searchPlaces = async () => {
    const response = await post(
      `customer/search-place`,
      {
        'query':query
      }
    )
    console.log(response)
    setPlaces([])
    setPlaces(response);
  };
  const searchLocation = async (lat, lon) => {
    const response = await post(
      `customer/search-location`,
      {
        'lat': lat,
        'lon':lon
      } 
    )
    console.log(response)
    onPlaceSelect(response)
    setQuery(response.formatted_address)
    getPlaceData({
      lat: lat,
      lng: lon,
      address: response.formatted_address,
      place_id:response.place_id
    })
    setPlaces([])
  };
  const handleClick = (place) => {
    onPlaceSelect(place)
    setQuery(place.formatted_address)
    
    getPlaceData({
      lat: place.geometry.location.lat,
      lng: place.geometry.location.lng,
      address: place.formatted_address,
      place_id:place.place_id
    })
    setPlaces([])
  };
  const updateField = async (lat,lon) =>{ 
    await searchLocation(lat, lon)
  }

  const detectLocation = () => {
    console.log("Detect") 
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;
          await searchLocation(lat, lon);
        },
        (err) => {
        }
      );
    } else {
      // setError("Geolocation is not supported by this browser.");
      // setLoading(false);
    }
  };
  useImperativeHandle(ref, () => ({
    updateField
  }));
  
  
  return (
    <React.Fragment>
      <div className="location_input">
        <input
          type="text"
          name="location"
          className="location_search"
          placeholder= {t("enter_your_location")}
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            searchPlaces();
            // return 
          }}
        />
        <div className="detect_btn" onClick={detectLocation}>
          <Location /> {t("detect")}
        </div>
      </div>

      <ul>
        {places.map((place,index) => (
          <li key={place.place_id}
           onClick={() => handleClick(place)}
            style={{
              backgroundColor: "red",
              color: "white",
              border: "0.5px solid white",
              padding: "10px",
              margin: "5px 0",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
            }}
          >
          {place.name} - {place.formatted_address}
          </li>
        ))}
      </ul>
    </React.Fragment>
  );
}
)
export default PlaceSearch;
